import { Text } from "@radix-ui/themes";
import {
  BILLING_INTERVALS,
  calculateAnnualAmount,
  formatCurrency,
} from "@/types/breeze/AnythinkPay";

interface BillingIntervalDisplayProps {
  interval: string;
  intervalCount: number;
  showAnnualEquivalent?: boolean;
  amount?: number;
  currency?: string;
}

export function BillingIntervalDisplay({
  interval,
  intervalCount,
  showAnnualEquivalent = false,
  amount,
  currency,
}: BillingIntervalDisplayProps) {
  const intervalLabel =
    BILLING_INTERVALS.find((i) => i.value === interval)?.label || interval;

  let displayText: string;
  if (intervalCount === 1) {
    displayText = intervalLabel;
  } else {
    displayText = `Every ${intervalCount} ${intervalLabel.toLowerCase()}s`;
  }

  if (showAnnualEquivalent && amount && currency) {
    const annualAmount = calculateAnnualAmount(amount, interval, intervalCount);
    if (annualAmount !== amount) {
      const formattedAnnual = formatCurrency(annualAmount, currency);
      return (
        <Text>
          {displayText} ({formattedAnnual}/year)
        </Text>
      );
    }
  }

  return <Text>{displayText}</Text>;
}
